
import { BigNumber, ethers } from "ethers";
import pairAbi from "../abi/PairContract.json";
import D3Token from "../abi/D3Token.json";
import sOHMv2 from "../abi/sOhmv2.json";
import OlympusStakingv2ABI from "../abi/OlympusStakingv2.json";
import axios from "axios";

export const defi_busd = {
    networkAddrs: {
        Mainnet: {
            bondAddress: "0x3597e1612a0336825e390f53be7E55FfA247f98e",
            reserveAddress: "0xf9A3b7A967084630c5a3100f88ef981e3BBb1DAa",
        },
        Testnet: {
            bondAddress: "0x7BB53Ef5088AEF2Bb073D9C01DCa3a1D484FD1d2",
            reserveAddress: "0x11BE404d7853BDE29A3e73237c952EcDCbBA031E",
        },
    },
    lpUrl: "https://pancakeswap.finance/add/0xB4c16Ed711c06b84e4312d5f09bcbD88E4F4d3b6/0xe9e7cea3dedca5984780bafc599bd69add087d56"
};

export const addresses = {
    97: {
        DAI_ADDRESS: "0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee",
        BUSD_ADDRESS: "0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee", // duplicate
        D3_ADDRESS: "0x4D996cA1B4A9697E30c50099C9F5f1d30bEeE953",
        STAKING_ADDRESS: "0xE8a46747910be8dbC65fe6A0916E9D6b1e290E23",
        STAKING_HELPER_ADDRESS: "0x6758eECbeC08D965d484A0faE53E0ec24e1282b6",
        // OLD_STAKING_ADDRESS: "0x6758eECbeC08D965d484A0faE53E0ec24e1282b6",
        sD3_ADDRESS: "0xfB6Cb6b42e0621520B08a7A1f79Cdf07618a9CD8",
        DISTRIBUTOR_ADDRESS: "0x4b3763061Ee2dB1F1357ec52440369C202EF98E2",
        BONDINGCALC_ADDRESS: "0x4B5654E3352f692300dDCf532d3eAe1f7b91ac37",
        TREASURY_ADDRESS: "0x70DbA5Fe0fc0a481763Dce33a048609EeDBea52c",

        CIRCULATING_SUPPLY_ADDRESS: "0x3F68784370159c26974bed44533A3dAE1DBc92Fb",
        BOND_HELPER: "0x8a1C08cf83e7291C98d7ce0957F8a0e766F892B8",
        WSOHM_ADDRESS: "0xe73384f11Bb748Aa0Bc20f7b02958DF573e6E2ad",
        REDEEM_HELPER_ADDRESS: "0xBd35d8b2FDc2b720842DB372f5E419d39B24781f",
        GOHM_ADDRESS: "0xcF2D6893A1CB459fD6B48dC9C41c6110B968611E",
    },
    56: {
        DAI_ADDRESS: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
        BUSD_ADDRESS: "0xe9e7cea3dedca5984780bafc599bd69add087d56", // duplicate
        D3_ADDRESS: "0xB4c16Ed711c06b84e4312d5f09bcbD88E4F4d3b6",
        STAKING_ADDRESS: "0x53F4a84F320f571D11fc1F078Dd97321Fdda780b",
        STAKING_HELPER_ADDRESS: "0x0A820314e761c18841015f6c7aBB752edB8d604a",
        // OLD_STAKING_ADDRESS: "0x6758eECbeC08D965d484A0faE53E0ec24e1282b6",
        sD3_ADDRESS: "0x34b51Bf2F838f819563E86a1118EECbDf0c31Ea1",
        DISTRIBUTOR_ADDRESS: "0x91a2645A5f18F4b2D85960e1A6165C75E3138A96",
        BONDINGCALC_ADDRESS: "0x45016fa7e9476675fF796F054Abda796126dDA62",
        TREASURY_ADDRESS: "0xA7930111Db88dc1bD9cB3197db535B9AefAFdD92",
        DIVIDEND_ADDRESS: "0x54ec9C5FabAc0F54006BD9ceb65e0f054E529379",
        DIABOND_ADDRESS: "0x2b70D81b1248BBF56Ce289061D484a240902C19C",
        CCF_ADDRESS: "0xdF2BCc1578B2eB8e1382B9938BD7053Aa4eB0FF3",
        CIRCULATING_SUPPLY_ADDRESS: "0x3F68784370159c26974bed44533A3dAE1DBc92Fb",
        BOND_HELPER: "0x8a1C08cf83e7291C98d7ce0957F8a0e766F892B8",
        WSOHM_ADDRESS: "0xd757B746B34512E885CaB18a183fC0916070E5c7",
        REDEEM_HELPER_ADDRESS: "0x167aB542480eCF24EBf90882a28Bd96296D1fD55",
        GOHM_ADDRESS: "0xcF2D6893A1CB459fD6B48dC9C41c6110B968611E",

    },
};


const provider = new ethers.providers.JsonRpcProvider("https://bsc-dataseed.binance.org/");

export async function getMarketPrice() {
    // marketprice, liquidity
    const PairContractABI = pairAbi.abi;
    const defi_busd_address = defi_busd.networkAddrs.Mainnet.reserveAddress;
    const pairContract = new ethers.Contract(defi_busd_address || "", PairContractABI, provider);
    const reserves = await pairContract.getReserves();
    const marketPrice = (Number(reserves[1].toString()) / Math.pow(10, 18)) / (Number(reserves[0].toString()) / Math.pow(10, 9) + 1);

    const amount = Number(reserves[0].toString()) / Math.pow(10, 9);
    const liquidity = marketPrice * amount * 2;

    // marketcap
    const d3Contract = new ethers.Contract(
        addresses[56].D3_ADDRESS,
        D3Token.abi,
        provider,
    );

    const totalSupply = (await d3Contract.totalSupply()) / Math.pow(10, 9);
    const marketCap = Number(totalSupply) * Number(marketPrice);

    // APY
    const stakingContract = new ethers.Contract(
        addresses[56].STAKING_ADDRESS,
        OlympusStakingv2ABI.abi,
        provider,
    );

    const sohmMainContract = new ethers.Contract(
        addresses[56].sD3_ADDRESS,
        sOHMv2.abi,
        provider,
    );

    const epoch = await stakingContract.epoch();
    const stakingReward = epoch.distribute;
    const circ = await sohmMainContract.circulatingSupply();
    const stakingRebase = Number(stakingReward.toString()) / Number(circ.toString());
    const stakingAPY = Math.pow(1 + stakingRebase, 365 * 2) - 1;

    return { marketPrice: marketPrice, liquidity: liquidity, marketCap: marketCap, apy: stakingAPY };
}
